const mutations = {
    doSearch(state, data) {
        const activateFacet = (group) => {
            if (!group.facets) {
                return group;
            }

            group.facets.map(facet => {
                facet.isActive = state.activeFacets.indexOf(facet.id) !== -1
                return facet;
            })

            return group;
        }

        const maxItem = data.results.length - 1;

        for (let i = 0; i < data.results.length; i++) {
            let prev, next

            prev = i <= 0 ? data.results[maxItem] : data.results[i - 1];
            next = i >= maxItem ? data.results[0] : data.results[i + 1];

            data.results[i].prev = prev;
            data.results[i].next = next;
        }

        state.results = data.results;
        state.facets = data.facets.map(activateFacet);

        state.facets.forEach(group => {
            if (group.group !== '__year') {
                return;
            }
            state.yearRange = {
                min: group.stats.min,
                max: group.stats.max,
                _min: group.stats.min,
                _max: group.stats.max,
            }
        });
    },

    setPaginationVisibility(state, showPagination){
        state.showPagination = showPagination
    },

    setPagination(state, currentPage){
      state.currentPage = currentPage
    },

    toggleLoadingState(state, status = false) {
        state.isLoading = status;
    },

    setLoadingOnFacet(state, payload) {
        state.facets = state.facets.map(facetGroup => {
            facetGroup.facets = facetGroup.facets.map(facet => {
                facet.isLoading = facet.id === payload
                return facet;
            });

            return facetGroup;
        });
    },

    setSearchQuery(state, query) {
        state.query = query;
    },

    toggleFacet(state, {id, exclusive}) {
        const activeIDs = [];

        const toggle = (facetID, facetGroup, resetState = false) => {
            facetGroup.facets = facetGroup.facets.map(facet => {
                facet.isActive = facet.id === facetID ? !facet.isActive : !resetState && facet.isActive;

                if (facet.isActive) {
                    activeIDs.push(facet.id);
                }

                return facet;
            });


            return facetGroup;
        }

        state.facets = state.facets.map(facetGroup => toggle(id, facetGroup, exclusive));
        state.activeFacets = activeIDs;
    },


    resetFacets(state) {
        state.yearRange = {
            min: '',
            max: '',
            _min: 0,
            _max: 0
        };

        state.facets = state.facets.map(group => {
            group.facets.map(f => {
                f.isActive = false;
                f.isLoading = false;
                return f;
            });

            return group;
        })

        state.activeFacets = [];
    },

    setYearRange(state, payload) {
        const {_min, _max} = state.yearRange;

        // state.yearRange[payload.range] = Math.max(Math.min(_max, payload.value), _min);
        state.yearRange[payload.range] = payload.value;
    }
};

export default mutations;